import type { LayoutInfo } from '~/hooks/layout/types'

const DEFAULT_TOLERANCE = 1

export const layoutUtils = {
  hasLayoutChanged(
    currentLayout: LayoutInfo | undefined | null,
    newLayout: { width: number; height: number },
    tolerance: number = DEFAULT_TOLERANCE
  ): boolean {
    if (!currentLayout) return true

    return (
      Math.abs(currentLayout.width - newLayout.width) > tolerance ||
      Math.abs(currentLayout.height - newLayout.height) > tolerance
    )
  },
}
